import { object, string, array } from "yup";

export default intl  => {
  const requiredText = intl.formatMessage({ id: "app.form.required" });

  return object().shape({
    name: string().required(requiredText),
    description: string().required(requiredText),
    streamsourceIds: array().required(requiredText).of(string().required(requiredText))
  });
};
